import { Capacitor } from '@capacitor/core';

/** True when running inside Capacitor Android/iOS shell (not mobile browser). */
export function isNativeApp() {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return Boolean(typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.());
  }
}

export function getNativePlatform() {
  try {
    return Capacitor.getPlatform();
  } catch {
    return 'web';
  }
}
